var _defs, _path, _path2, _g, _path3, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOssStatement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143 143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M57.1 83.7h52.2M57.1 95.4h52.2M57.1 107.1h52.2M121.8 59V41.7l-18.4-16.9H47.7c-2 0-3.6 1.6-3.6 3.6v92c0 2 1.6 3.6 3.6 3.6h70.5c2 0 3.6-1.6 3.6-3.6V59.1zM39.5 32H35c-2 0-3.6 1.6-3.6 3.6v77.5c0 2 1.6 3.6 3.6 3.6h4.5M26.9 39.3h-2.1c-2 0-3.6 1.6-3.6 3.6v63c0 2 1.6 3.6 3.6 3.6h2.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M103.4 24.8v16.8l18.4.1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M57.1 83.7h52.2M57.1 95.4h52.2M57.1 107.1h52.2M121.8 59V41.7l-18.4-16.9H47.7c-2 0-3.6 1.6-3.6 3.6v92c0 2 1.6 3.6 3.6 3.6h70.5c2 0 3.6-1.6 3.6-3.6V59.1zM39.5 32H35c-2 0-3.6 1.6-3.6 3.6v77.5c0 2 1.6 3.6 3.6 3.6h4.5M26.9 39.3h-2.1c-2 0-3.6 1.6-3.6 3.6v63c0 2 1.6 3.6 3.6 3.6h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M103.4 24.8v16.8l18.4.1"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M60.1 67.2l-5.8-10c-2.6-4.5.6-10 5.8-10 5.1 0 8.4 5.6 5.8 10l-5.8 10zM64.3 70.6s28.1-1.3 29-7.9c.8-6.2-17.3-4.9-18.5-10.6s12.8-7 12.8-7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 94.8,
    cy: 43.5,
    r: 3.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "DI_4L_main",
    cx: 60.1,
    cy: 53.9,
    r: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOssStatement);
export default __webpack_public_path__ + "static/media/OssStatement.fc1d0039794230aa4db71291566c8797.svg";
export { ForwardRef as ReactComponent };